import React from "react";
import { Users, Clock, PlaneTakeoff, Euro, Hotel, Sun, Moon } from "lucide-react";
import { eur, hours } from "./shared";

export function SiteStatsStrip({ stats, compact = false }) {
  if (!stats) return null;
  const cells = [
    { icon: Users, label: "Salariés", value: stats.nb_salaries, sub: `${stats.nb_actifs} actifs${stats.nb_saisonniers ? ` · ${stats.nb_saisonniers} saisonnier${stats.nb_saisonniers > 1 ? "s" : ""}` : ""}`, testid: "site-stat-salaries" },
    { icon: Clock, label: "Heures planifiées", value: hours(stats.heures_mois), sub: "ce mois", testid: "site-stat-heures" },
    { icon: PlaneTakeoff, label: "Congés en attente", value: stats.conges_pending, sub: "à traiter", testid: "site-stat-conges", warn: stats.conges_pending > 0 },
    { icon: Euro, label: "CA du mois", value: eur(stats.ca_mois), sub: `${eur(stats.ca_annee)} sur l'année`, testid: "site-stat-ca", highlight: true },
  ];
  if (stats.nb_units > 0) {
    cells.push({ icon: Hotel, label: "Réservations", value: stats.reservations_mois, sub: `${stats.nb_units} unité${stats.nb_units > 1 ? "s" : ""}`, testid: "site-stat-resa" });
  }
  cells.push({
    icon: stats.open_today ? Sun : Moon, label: "Aujourd'hui", value: stats.open_today ? "Ouvert" : "Fermé",
    sub: stats.open_today ? "période d'ouverture" : "hors saison", testid: "site-stat-open", danger: !stats.open_today,
  });
  return (
    <div className={`grid grid-cols-2 ${compact ? "lg:grid-cols-3" : "lg:grid-cols-6"} border border-[#0A0A0A] bg-white`} data-testid="site-stats-strip">
      {cells.map((c) => (
        <div key={c.testid} data-testid={c.testid}
             className={`p-4 border-r border-b lg:border-b-0 border-[#0A0A0A] last:border-r-0 ${c.highlight ? "bg-[#002FA7] text-white" : c.danger ? "bg-[#FEF2F2]" : c.warn ? "bg-[#FFFBEB]" : ""}`}>
          <div className="flex items-center gap-2">
            <c.icon className={`h-3 w-3 ${c.highlight ? "text-[#FFD700]" : "text-[#002FA7]"}`} />
            <div className="text-[10px] uppercase tracking-[0.2em] font-bold opacity-70">{c.label}</div>
          </div>
          <div className="font-display text-xl lg:text-2xl font-black tracking-tighter mt-1">{c.value}</div>
          <div className={`text-[10px] mt-0.5 ${c.highlight ? "text-white/70" : "text-[#868E96]"}`}>{c.sub}</div>
        </div>
      ))}
    </div>
  );
}
